import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/_components/home/WelcomeScreen.tsx");
